import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

export const firebaseConfig = {
  apiKey: "AIzaSyBu3FIJ56UMKDjdqgQWbLB_iniQQ5_L7LQ",
  authDomain: "jimini-logistics.firebaseapp.com",
  projectId: "jimini-logistics",
  storageBucket: "jimini-logistics.firebasestorage.app",
  messagingSenderId: "622012372517",
  appId: "1:622012372517:web:17229b9d4ad57c5fb251cc",
  measurementId: "G-11SLVMQYVZ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app, "default");
export const storage = getStorage(app);
